import {
  Modal,
  ModalBody,
  ModalFooter,
  Body,
  Subhead,
  ModalHeader,
} from "@growtherapy/sprout-ui";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { useVisitorConnectRoomCallback } from "./admission/useVisitorConnectRoomCallback";
import { isAdmissionModalOpenAtom } from "./admission/state";
import { useOpenVisitorModalCallback } from "../modals/useOpenVisitorModalCallback";
import { useAdmissionTrackingEvents } from "./admission/useAdmissionTrackingEvents";

const HEADING_CONTENT = "Time to join your session";

export function AdmissionModal({
  isOpen,
  onJoin: handleJoin,
  onDismiss: handleDismiss,
  isLoading,
}: {
  isOpen: boolean;
  onJoin: () => void;
  onDismiss: () => void;
  isLoading: boolean;
}) {
  return (
    <Modal className="sm:mt-[10%]" isOpen={isOpen} onClose={handleDismiss}>
      <ModalHeader className="[&_h1]:sr-only flex justify-end">
        {HEADING_CONTENT}
      </ModalHeader>
      <ModalBody className="flex flex-col gap-2 items-center">
        <Subhead.Large aria-hidden>{HEADING_CONTENT}</Subhead.Large>
        <Body.Default>Your provider is ready for you!</Body.Default>
      </ModalBody>
      <ModalFooter
        className="flex justify-center rebrand:sm:pb-24"
        actions={[
          {
            key: "join-session",
            "aria-label": isLoading ? "Joining session" : "Join session",
            use: "primary",
            loading: isLoading,
            onClick: handleJoin,
            actionContent: "Join session",
          },
        ]}
      ></ModalFooter>
    </Modal>
  );
}

export function AdmissionModalWrapper() {
  const isOpen = useAtomValue(isAdmissionModalOpenAtom);
  const connectRoom = useVisitorConnectRoomCallback();
  const [isLoading, setIsLoading] = useState(false);
  const openVisitorModal = useOpenVisitorModalCallback();
  const {
    trackAdmissionPromptViewed,
    trackJoinSessionClicked,
    trackAdmissionPromptDismissed,
  } = useAdmissionTrackingEvents();

  useEffect(
    function handleTrackingAdmissionPromptViewed() {
      if (isOpen) {
        trackAdmissionPromptViewed();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isOpen],
  );

  return (
    <AdmissionModal
      isOpen={isOpen}
      onJoin={() => {
        trackJoinSessionClicked();
        setIsLoading(true);
        connectRoom().finally(() => setIsLoading(false));
      }}
      onDismiss={() => {
        trackAdmissionPromptDismissed();
        openVisitorModal(null);
      }}
      isLoading={isLoading}
    />
  );
}
